import React from 'react';
import './BillingModules.css';

const BillingModules = () => {
  return (
    <section id="billing" className="billing-modules">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Hospital Billing Software Modules</h2>
          <p className="section-subtitle">Purpose-built billing for Indian healthcare with our medical billing software: Railway, NABH, Non-NABH and CGHS</p>
        </div>

        <div className="modules-grid">
          <a href="#railway-billing" className="module-card" aria-label="Railway Billing">
            <h3 id="railway-billing">Railway Billing</h3>
            <p>
              Automated billing workflows for Railway health beneficiaries: package mapping, eligibility, pre-auths and claims submission with audit-ready reports.
            </p>
          </a>

          <a href="#nabh-billing" className="module-card" aria-label="NABH Billing">
            <h3 id="nabh-billing">NABH Billing</h3>
            <p>
              Compliant billing aligned with NABH standards: charge master, package capping, approvals, trail logs, and accreditation-ready analytics.
            </p>
          </a>

          <a href="#non-nabh-billing" className="module-card" aria-label="Non-NABH Billing">
            <h3 id="non-nabh-billing">Non-NABH Billing</h3>
            <p>
              Streamlined billing for non-NABH facilities with configurable rules, flexible discounts, and multi-tariff support.
            </p>
          </a>

          <a href="#cghs-billing" className="module-card" aria-label="CGHS Billing">
            <h3 id="cghs-billing">CGHS Billing</h3>
            <p>
              CGHS package handling, pre-authorization, claims tracking, and TPA workflows with status visibility and SLA alerts.
            </p>
          </a>
        </div>
      </div>
    </section>
  );
};

export default BillingModules;
